import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export interface ActivityRow {
  id: number | string;
  area?: string | null;
  resourceName?: string | null;
  note?: string | null;
  activityDate?: string | null;
  followUpDate?: string | null;
  cleared?: boolean | null;
}

const formatDate = (raw: string | null | undefined) => {
  if (!raw) return '';
  const date = new Date(raw);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const generateActivityTrackingPdf = (rows: ActivityRow[]) => {
  const filtered = rows;
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'letter' });

  const generatedAt = new Date().toLocaleString();

  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('Activity Tracking Report', 40, 40);

  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(120);
  doc.text(
    `Generated ${generatedAt} · ${filtered.length} item${filtered.length === 1 ? '' : 's'}`,
    40,
    58,
  );
  doc.setTextColor(0);

  autoTable(doc, {
    startY: 75,
    head: [['Area', 'Resource', 'Note', 'Activity Date', 'Follow-Up']],
    body: filtered.map((r) => [
      r.area ?? '',
      r.resourceName ?? '',
      r.note ?? '',
      formatDate(r.activityDate),
      formatDate(r.followUpDate),
    ]),
    styles: { fontSize: 9, cellPadding: 4, valign: 'top' },
    headStyles: { fillColor: [33, 33, 33], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: 160 },
      2: { cellWidth: 'auto' },
      3: { cellWidth: 90 },
      4: { cellWidth: 90 },
    },
    margin: { left: 40, right: 40 },
  });

  const dateStamp = new Date().toISOString().slice(0, 10);
  doc.save(`activity-tracking-${dateStamp}.pdf`);
};
